import { render, staticRenderFns } from "./chatFileMsg.vue?vue&type=template&id=5efc4770"
import script from "./chatFileMsg.vue?vue&type=script&lang=js"
export * from "./chatFileMsg.vue?vue&type=script&lang=js"
import style0 from "./chatFileMsg.vue?vue&type=style&index=0&id=5efc4770&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports